import {slideDown, slideUp} from "./helpers/animation";

document.addEventListener('DOMContentLoaded', () => {
	const activeClass = 'sort__button--active';
	const isMobile = window.innerWidth < 1024;

	window.catalogSortInit = function () {
		document.querySelectorAll('.js-sort').forEach((item) => {
			const button = isMobile ? item.querySelector('.js-sort-button-mobile') : item.querySelector('.js-sort-button-desktop');
			const select = item.querySelector('.js-sort-select');

			button.addEventListener('click', () => {
				const isOpen = item.classList.contains(activeClass)

				isOpen ? close() : open();
			})

			const open = () => {
				slideDown(select);
				item.classList.add(activeClass)
			}

			const close = () => {
				slideUp(select);
				item.classList.remove(activeClass)
			}

			window.closeCatalogSort = function () {
				close();
			};
			window.openCatalogSort = function () {
				open();
			};

		});
	}
	catalogSortInit();


});
